module.exports = {
  fetch: `query getPrompts($promptType: String, $productType: String) {
    prompts(filter: { type: { eq: $promptType }, productTypes: { contains: $productType }}) {
      id
      name {
        en
        es
      }
      description {
        en
        es
      }
      value {
        markup{
          en
          es
        }
        content {
          en
          es
        }
      }
      type
      productTypes
      createdAt
      updatedAt
    }
  }`,
  add: `mutation addPrompt($value: PromptInput) {
    upsertPrompt(prompt: $value) {
      id
    }
  }`,
  save: `mutation addPrompt($value: PromptInput) {
    upsertPrompt(prompt: $value) {
      id
    }
  }`,
  remove: `
    mutation removePrompts($ids: [ID]) {
      bulkRemovePrompts(ids: $ids)
  }`
};
